import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo_tiara.png";
import cafebazaar from "../../assets/images/cafebazaar.png";
import { RootState } from "../../redux/store";
import FoodDetailModal from "../foodDetailModal";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faBars,
  faChevronLeft,
  faClose,
  faSignOut,
} from "@fortawesome/free-solid-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { useState } from "react";
import OutOfServiceModal from "../outOfServiceModal";
import { signOut } from "../../redux/slices/userSlice";
import ConfirmSignOutModal from "../confirmSignOutModal";

const Layout = ({ children }: any) => {
  const showFoodDetailModal = useSelector(
    (state: RootState) => state.app.showFoodDetailModal
  );
  const showOutOfServiceModal = useSelector(
    (state: RootState) => state.app.showOutOfServiceModal
  );
  const isAuthenticated = useSelector((state: RootState) => state.user.isLogin);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const [showSignOutConfirmModal, setShowSignOutConfirmModal] = useState(false);
  const userInfo = useSelector((state: RootState) => state.user.userInfo);

  const location = useLocation();
  console.log();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const doSignOut = () => {
    setShowSignOutConfirmModal(false);
    dispatch(signOut());
    navigate("/");
  };

  return (
    <div>
      <nav className='bg-white border-b'>
        <div className='container mx-auto flex items-center space-between'>
          <div className='flex-auto'>
            <Link to='/'>
              <img
                src={logo}
                alt=''
                className='h-20 p-2'
              />
            </Link>
          </div>
          <div>
            <ul className='flex p-4 flex-row'>
              <li className='hidden lg:inline'>
                <Link
                  className='p-2'
                  to='/help'
                >
                  راهنمای ثبت نام و سفارش غذا
                </Link>
              </li>

              <li className='hidden lg:inline'>
                <Link
                  className='p-2'
                  to='/gallery'
                >
                  گالری تصاویر
                </Link>
              </li>

              <li className='hidden lg:inline'>
                <Link
                  className='p-2'
                  to='/feedback'
                >
                  انتقادات و پیشنهادات
                </Link>
              </li>
              <li className='hidden lg:inline'>
                <Link
                  className='p-2'
                  to='/aboutteam'
                >
                  درباره توسعه دهنده
                </Link>
              </li>
              <li className='hidden lg:inline'>
                <Link
                  className='p-2'
                  to='/about'
                >
                  درباره تیارا
                </Link>
              </li>
              <li className='hidden lg:inline'>
                <Link
                  className='p-2'
                  to='/contact'
                >
                  تماس با تیارا
                </Link>
              </li>
              {isAuthenticated && (
                <>
                  {location.pathname.includes("profile") ? (
                    <li>
                      <span
                        className='px-2 py-1 border rounded border-rose-900 text-rose-900'
                        onClick={() => setShowSignOutConfirmModal(true)}
                      >
                        <FontAwesomeIcon
                          icon={faSignOut}
                          className='pl-2'
                        />
                        خروج از حساب کاربری
                      </span>
                    </li>
                  ) : (
                    <li>
                      <Link
                        className='px-2 py-1 border rounded border-rose-900 text-rose-900'
                        to='/profile/info'
                      >
                        {userInfo.name} <FontAwesomeIcon icon={faChevronLeft} />
                      </Link>
                    </li>
                  )}
                </>
              )}

              <li>
                {!isAuthenticated && (
                  <Link
                    className='p-2'
                    to='/signin'
                  >
                    ورود
                  </Link>
                )}
              </li>

              <li
                className='inline lg:hidden'
                onClick={() => setIsMenuOpen((prev) => !prev)}
              >
                <FontAwesomeIcon
                  icon={isMenuOpen ? faClose : faBars}
                  className=' text-xl pr-2 w-5'
                />
              </li>
            </ul>
          </div>
        </div>

        <div
          className={`w-full h-full fixed z-50 ${
            isMenuOpen ? "block" : "hidden"
          }`}
          onClick={() => {
            setIsMenuOpen(false);
          }}
        ></div>

        <div
          className={`absolute bg-white w-full lg:hidden z-50 border-b ${
            isMenuOpen ? "block" : "hidden"
          }`}
        >
          <ul className='z-10'>
            <li className='p-2 border-t'>
              <Link
                className='p-2'
                to='/help'
              >
                راهنمای ثبت نام و سفارش غذا
              </Link>
            </li>
            <li className='p-2 border-t'>
              <Link
                className='p-2'
                to='/gallery'
              >
                گالری تصاویر
              </Link>
            </li>
            <li className='p-2 border-t'>
              <Link
                className='p-2'
                to='/feedback'
              >
                انتقادات و پیشنهادات
              </Link>
            </li>
            <li className='p-2 border-t'>
              <Link
                className='p-2'
                to='/aboutteam'
              >
                درباره توسعه دهنده
              </Link>
            </li>
            <li className='p-2 border-t'>
              <Link
                className='p-2'
                to='/about'
              >
                درباره تیارا
              </Link>
            </li>
            <li className='p-2 border-t'>
              <Link
                className='p-2'
                to='/contact'
              >
                تماس با تیارا
              </Link>
            </li>
          </ul>
        </div>
      </nav>

      {location.pathname !== "/" && (
        <div className='container mx-auto flex items-center'>
          <Link
            className='border rounded my-2 py-1 px-2 font-bold border-rose-900 text-rose-900 px-2 bg-white'
            to={"/"}
          >
            <FontAwesomeIcon
              className='ml-1'
              icon={faArrowRight}
            />
            بازگشت به منوی سفارش
          </Link>
        </div>
      )}

      <div>{children}</div>
      <footer className='border-t mt-8 bg-white'>
        <div className='container py-1 mx-auto flex items-center'>
          <div className='flex-1'>
            تمامی حقوق برای رستوران تیارا محفوظ است © 2023
          </div>

          <div className='flex'>
            <Link
              to='https://myket.ir/app/com.parsroyan.tiararestaurant'
              target='_blank'
              rel='noopener noreferrer'
              style={{ lineHeight: "1" }}
              className='cursor-pointer'
            >
              <img
                alt='Myket'
                className='inline-block  h-9 ml-2'
                src={"https://myket.ir/core/images/logo/get2-fa.png"}
              />
            </Link>

            <Link
              to='https://cafebazaar.ir/app/com.parsroyan.tiararestaurant'
              target='_blank'
              rel='noopener noreferrer'
              style={{ lineHeight: "1" }}
              className='cursor-pointer'
            >
              <img
                alt='Cafe Bazzar'
                className='inline-block  h-9 ml-2'
                src={cafebazaar}
              />
            </Link>

            <Link
              to='https://instagram.com/Ahwaz_Tiara_Restaurant'
              target='_blank'
              rel='noopener noreferrer'
              style={{ lineHeight: "1" }}
              className='text-4xl cursor-pointer'
            >
              <FontAwesomeIcon
                icon={faInstagram}
                className='text-rose-900'
              />
            </Link>
          </div>
        </div>

        <div className='text-center p-4 border-t'>
          <div className='flex items-center align-center justify-center	'>
            <div className='max-w-xs'>
              <img
                referrerPolicy='origin'
                id='jxlznbqewlaojzpesizpwlao'
                style={{ cursor: "pointer" }}
                onClick={() => {
                  window.open(
                    "https://logo.samandehi.ir/Verify.aspx?id=124794&p=rfthuiwkaodsjyoepfvlaods",
                    "Popup",
                    "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30"
                  );
                }}
                alt='logo-samandehi'
                src='https://logo.samandehi.ir/logo.aspx?id=124794&p=nbpdodrfshwlyndtbsiyshwl'
              />
            </div>
            <div className='max-w-xs'>
              <a href='https://trustseal.enamad.ir/?id=322408&amp;Code=thbMs0dvLBEpgE5STdWN'>
                <img
                  referrerPolicy='origin'
                  src='https://Trustseal.eNamad.ir/logo.aspx?id=322408&amp;Code=thbMs0dvLBEpgE5STdWN'
                  alt='eNamad'
                  style={{ cursor: "pointer" }}
                  id='thbMs0dvLBEpgE5STdWN'
                />
              </a>
            </div>
          </div>

          <div>
            طراحی و پیاده سازی:{" "}
            <Link
              className='text-rose-900'
              to={"/aboutteam"}
            >
              تیم نرم افزاری پارس رویان
            </Link>
          </div>
          <div className='mt-2 text-xs'> نسخه 2.0</div>
        </div>
      </footer>

      {showFoodDetailModal && <FoodDetailModal />}
      {showOutOfServiceModal && <OutOfServiceModal />}
      {showSignOutConfirmModal && (
        <ConfirmSignOutModal
          hideModal={() => setShowSignOutConfirmModal(false)}
          signOut={() => doSignOut()}
        />
      )}
    </div>
  );
};

export default Layout;
